import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import Card, { CardPadding } from '../components/Card';
import deviceStore from '../stores/deviceStore';
import Button from '../components/Button';
import formatDescription from '../helpers/formatDescription';

export default function Success() {
  const ds = deviceStore();

  const handleTopButtonClick = () => {
    window.scrollTo(0, 0);
  };

  if (!ds.device) return <Navigate to='/' />;

  const meta = JSON.parse(ds.device.device_token_metadata);

  return (
    <Card className='relative'>
      <img src={meta.image} alt='pbt 이미지' />
      <CardPadding>
        <div className='success-summary'>
          <h2 className='text-xl'>
            {
              meta.attributes.find(
                (attribute: any) => attribute.trait_type === 'Title'
              ).value
            }
          </h2>
          <p className='text-sm font-bold'>
            {
              meta.attributes.find(
                (attribute: any) => attribute.trait_type === 'Artist'
              ).value
            }
          </p>
          <p className='text-sm font-bold'>
            {
              meta.attributes.find(
                (attribute: any) => attribute.trait_type === 'Year'
              ).value
            }
          </p>
          <p className='text-2xs mt-4'>
            {
              meta.attributes.find(
                (attribute: any) => attribute.trait_type === 'Medium'
              ).value
            }
          </p>
          <p className='text-2xs'>
            {
              meta.attributes.find(
                (attribute: any) => attribute.trait_type === 'Dimensions'
              ).value
            }
          </p>
        </div>
        <h3 className='success-title'>Artwork</h3>
        <div className='success-contents'>
          <p>{meta.description}</p>
        </div>
        <h3 className='success-title'>Artist</h3>
        <div className='success-contents'>
          <p>{meta['Artist Detail']}</p>
        </div>
        <h3 className='success-title'>Exhibition</h3>
        <div className='success-contents'>
          {
            meta.attributes.find(
              (attribute: any) => attribute.trait_type === 'Exhibition'
            ).value
          }
        </div>
        <h3 className='success-title'>Provenance</h3>
        <div className='success-contents'>
          <p
            dangerouslySetInnerHTML={{
              __html: formatDescription(
                meta.Provenance.replaceAll('\n', '<br/>')
              ),
            }}
          ></p>
        </div>
        <div className='success-footer'>
          <Button className='text-xs text-black' onClick={handleTopButtonClick}>
            top
          </Button>
          <img
            width='62'
            src='/assets/ATVT_type_logo.svg'
            alt='아티비스트 로고'
          />
        </div>
      </CardPadding>
    </Card>
  );
}
